import { BankAutofill } from "types/Models/bankAutofill";
import {
  MANUAL_BANK_ACCOUNT_INITIAL_VALUES,
  ManualBankAccountValues,
} from "types/Models/manualBankAccount";

export const getManualBankInitialValues = (
  bank?: BankAutofill
): ManualBankAccountValues => {
  if (!bank) return MANUAL_BANK_ACCOUNT_INITIAL_VALUES;

  return {
    name: bank.name || "",
    account_number: bank.account_number || "",
    routing_number: bank.routing_number || "",
    bank_details_entity_name: bank.bank_details_entity_name || "",
    address: bank.address || "",
    is_confirmed: false,
  };
};
